import React, { useState } from "react";
import {
  Text,
  Button,
  FormControl,
  Input,
  InputRightElement,
  InputGroup,
  Flex,
} from "@chakra-ui/react";

import { FaShoePrints } from "react-icons/fa";

import MailchimpSubscribe from "react-mailchimp-subscribe";

export const Newsletter = () => {
  const [email, setEmail] = useState("");

  return (
    <Flex
      w="100%"
      justify="center"
      textAlign="center"
      direction="column"
      align="center"
    >
      <Text fontFamily="Work Sans" fontWeight="black" color="white" mb="22px">
        The barrier between reality and fantasy is thin and sometimes a click
        can change everything
      </Text>
      <MailchimpSubscribe
        url="https://raidsquare.us10.list-manage.com/subscribe/post?u=39a9be67f4da6a8064afba543&amp;id=1129666d9a&amp;f_id=0087cee5f0"
        render={({ subscribe, status, message }) => (
          <>
            <form
              onSubmit={(e) => {
                e.preventDefault();

                email &&
                  email.indexOf("@") > -1 &&
                  subscribe({
                    EMAIL: email,
                  });
              }}
            >
              <InputGroup w="350px">
                <FormControl isRequired>
                  <Input
                    color="white"
                    variant="outline"
                    minHeight="64px"
                    border="2px solid white"
                    placeholder="Enter your email"
                    _placeholder={{ color: "white" }}
                    borderRadius="0px"
                    type="email"
                    px="34px"
                    onChange={(event) => setEmail(event.currentTarget.value)}
                  />
                </FormControl>
                <InputRightElement w="64px" h="64px">
                  <Button
                    w="64px"
                    h="64px"
                    type="submit"
                    borderRadius="50px"
                    background="transaprent"
                    _hover={{ background: "transaprent" }}
                    _active={{ background: "transaprent" }}
                  >
                    <FaShoePrints color="white" size="20px" />
                  </Button>
                </InputRightElement>
              </InputGroup>
            </form>

            {status === "sending" && (
              <Text
                fontFamily="Work Sans"
                fontWeight="black"
                color="white"
                fontSize="sm"
                mt="12px"
              >
                Sending...
              </Text>
            )}
            {status === "error" && (
              <Text
                fontFamily="Work Sans"
                fontWeight="black"
                color="red"
                fontSize="sm"
                mt="12px"
              >
                Email address is invalid or already registered
              </Text>
            )}
            {status === "success" && (
              <Text
                fontFamily="Work Sans"
                fontWeight="black"
                color="#0018ff"
                fontSize="sm"
                mt="12px"
              >
                Subscribed !
              </Text>
            )}
          </>
        )}
      />
    </Flex>
  );
};
